(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'MagazineContest',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		// this will prevent the drowdown header to change.
		$form.on('shown.bs.select', function optgroupSelectAll(e) {
			e.stopPropagation();
		});

		$('select#magazinecontest-where_to_next').change(function changing(e) {
			// loop thru all options of hidden multi select input
			$('#magazinecontest-where_to_next option').each(function selecting(e, val) {
				var $self = $(this);

				// show span under select
				if ($self.is(":selected")) {
					$('.selected-destination[data-destination-id = "' + val.value + '"]').removeClass('hidden');
				// hide span
				} else {
					$('.selected-destination[data-destination-id = "' + val.value + '"]').addClass('hidden');
				}
			});
		}).trigger('change');
	};

}(jQuery, window.Adzuki || {}));
